import React, {useMemo} from 'react';
import isEmpty from 'lodash/fp/isEmpty';
import mapValues from 'lodash/fp/mapValues';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import useSearch from '../../hooks/useSearch';
import Search from '../Inputs/Search';
import DateIntervalPicker from '../Forms/DateIntervalPicker';
import RecursiveTable from './RecursiveTable';
import {makeTableData} from './utils';
import useStyles from './styles';

const View = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  data,
  isBusy,
}) => {

  return <Grid container>
    <Grid item xs={12}>
      <ReportHeader
        {...{startDate, setStartDate, endDate, setEndDate}}
      />
    </Grid>
    <Grid item xs={12}>
      <ReportTable
        {...{isBusy, data}}
      />
    </Grid>
  </Grid>;
};

export const ReportTable = ({
  data,
  isBusy,
}) => {

  const classes = useStyles();
  const tableData = useMemo(() => mapValues(makeTableData)(data), [data]);
  const [search, clearSearch, filteredData] = useSearch(tableData);

  const columns = [
    { width: 200 , label: 'Integrado'     , dataKey: 'member'   },
    { width: 150 , label: 'Peso (Kg)'     , dataKey: 'weight'   },
    { width: 170 , label: 'Distâcia (Km)' , dataKey: 'distance' },
    { width: 100 , label: 'Idade Atual'   , dataKey: 'age'      },
    { width: 100 , label: 'Tipo'          , dataKey: 'slotType' },
    { width: 150 , label: 'Valor (R$)'    , dataKey: 'value'    },
  ];

  return isBusy
    ? <Grid container xs={12} justify='center'>
      <CircularProgress className={classes.spinner}/>
    </Grid>
    : <>
      <Search {...{clearSearch}} {...{search}}/>
      <Grid
        container
        direction='column'
        className={classes.tableContainer}
      >
        {!isEmpty(filteredData)
          ? <Grid item xs={12}>
            <RecursiveTable
              data={filteredData}
              {...{columns}}
            />
          </Grid>
          : <Grid container xs={12} justify='center'>
            <Typography variant='h6' className={classes.title}>
              Nenhum item encontrado...
            </Typography>
          </Grid>
        }
      </Grid>
    </>;
};

export const ReportHeader = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate
}) => {

  const classes = useStyles();

  return <Grid
    container
    justify='center'
    alignItems='center'
    className={classes.header}
  >
    <Grid item xs={12}>
      <DateIntervalPicker
        {...{startDate, setStartDate, endDate, setEndDate}}
      />
    </Grid>
  </Grid>;
};

export default View;
